import { getRequest, formRequest, deleteRequest } from "@react/helpers/fetch"

export const fetchTaskPhotos = (projectId, taskId) =>
  getRequest(`/projects/${projectId}/project_tasks/${taskId}/photos.json`)

export const uploadTaskPhoto = (projectId, taskId, file, caption, takenAt) => {
  const form = new FormData()
  form.append("image", file)
  if (caption)  form.append("caption",  caption)
  if (takenAt)  form.append("taken_at", takenAt)
  return formRequest({
    method: "POST",
    url:    `/projects/${projectId}/project_tasks/${taskId}/photos.json`,
    form,
  })
}

export const destroyTaskPhoto = (projectId, taskId, id) =>
  deleteRequest(`/projects/${projectId}/project_tasks/${taskId}/photos/${id}.json`)
